import React, { createContext, useCallback, useContext, useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'

export const ConfirmDialogContext = createContext(null)

export const useConfirmDialogContext = () => useContext(ConfirmDialogContext)

export const ConfirmDialogProvider = ({ children }) => {
    const [dialogState, setDialogState] = useState({
        visible: false,
        message: '',
        resolve: null,
    })

    const confirm = useCallback(message => {
        return new Promise(resolve => {
            setDialogState({ visible: true, message, resolve })
        })
    }, [])

    const handleConfirm = () => {
        dialogState.resolve(true)
        setDialogState({ ...dialogState, visible: false })
    }

    const handleCancel = () => {
        dialogState.resolve(false)
        setDialogState({ ...dialogState, visible: false })
    }

    return (
        <ConfirmDialogContext.Provider value={{ confirm }}>
            {children}

            <Modal isOpen={dialogState.visible} toggle={handleCancel} backdrop="static">
                <ModalHeader toggle={handleCancel}>Confirm</ModalHeader>
                <ModalBody>{dialogState.message}</ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button color="primary" onClick={handleConfirm}>
                        Confirm
                    </Button>
                </ModalFooter>
            </Modal>
        </ConfirmDialogContext.Provider>
    )
}
